import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import TechVideoBackground from './TechVideoBackground';

interface CTABannerProps {
  title?: React.ReactNode;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
}

const CTABanner: React.FC<CTABannerProps> = ({
  title = <>Ready to Multiply Your <span style={{ color: 'white' }} className="gradient-text">Team's Capacity</span>?</>,
  subtitle = 'Schedule a free diagnostic and discover where AI agents generate the most impact on your operations.',
  buttonText = 'Schedule Free Diagnostic',
  buttonLink = '/contact',
}) => {
  return (
    <section className="section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{
            background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
            borderRadius: 'var(--radius-lg)',
            padding: '64px 48px',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <TechVideoBackground variant="dark" opacity={0.3} />

          <div style={{ position: 'relative', zIndex: 2 }}>
            <h2 style={{
              fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
              fontWeight: 800,
              marginBottom: 16,
              color: 'white',
            }}>
              {title}
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: 'rgba(255,255,255,0.7)',
              maxWidth: 600,
              margin: '0 auto 40px',
              lineHeight: 1.7,
            }}>
              {subtitle}
            </p>

            <div style={{
              display: 'flex',
              gap: 16,
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}>
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
                <Link
                  to={buttonLink}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '16px 36px',
                    background: 'white',
                    borderRadius: 100,
                    fontSize: '1.05rem',
                    fontWeight: 600,
                    color: '#0f172a',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
                  }}
                >
                  {buttonText} <ArrowRight size={18} />
                </Link>
              </motion.div>
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
                <Link
                  to="/products"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '16px 36px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: 100,
                    fontSize: '1.05rem',
                    fontWeight: 600,
                    color: 'white',
                  }}
                >
                  Explore Products
                </Link>
              </motion.div>
            </div>

            <div style={{
              marginTop: 32,
              fontSize: '0.8rem',
              color: 'rgba(255,255,255,0.5)',
            }}>
              Free diagnostic. Setup in minutes. Results from day one.
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
